export default __webpack_public_path__ + "static/Manufacture-Blog-Image-16e34dcd57c011cb1cd797b6b417689d.png";